<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.prevent="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>상품별 A/S 고장 증상 설정</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="save">저장</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text class="pt-0">
          <v-row class="mb-4" align="center">
            <v-col cols="3" class="pr-0">
              <div class="info-chip">고장 증상 설정시 참고하세요.</div>
            </v-col>
            <v-col cols="9">
              <p class="mb-0 caption">
                생성한 정품 인증 코드 상품과 코드 입력 없이 미인증 설정한 상품에 대해 설정이 가능합니다.
              </p>
              <p class="mb-0 caption">
                쇼핑몰에서 AS 신청시 상품에 대한 고장 증상을 선택할 수 있습니다.
              </p>
              <p class="mb-0 caption"><span class="blue--text"> 고장 증상은 입력란에 쉼표(,)로 구분하여 등록이 가능</span>합니다.</p>
            </v-col>
          </v-row>

          <v-data-table
            class="as-symptom-table"
            :headers="headers"
            :items="items"
            :loading="loading"
            :items-per-page="-1"
            hide-default-footer
            item-key="product_no"
          >
            <template v-slot:[`item.image`]="{ item }">
              <v-row no-gutters class="image-row">
                <v-col class="d-flex justify-center">
                  <v-img
                    :src="item.list_image || adminDefaultImg"
                    :lazy-src="adminDefaultImg"
                    width="60px"
                    height="60px"
                    contain
                    class="as-symptom-image"
                  ></v-img>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.product_info`]="{ item }">
              <div class="text-start">
                <p class="mb-0 caption">상품명 : {{ item.product_name || "-" }}</p>
                <p class="mb-0 caption">상품코드 : {{ item.product_code || "-" }}</p>
              </div>
            </template>

            <template v-slot:[`item.symptoms`]="{ item }">
              <v-textarea
                v-model="item.symptoms"
                outlined
                dense
                rows="2"
                placeholder="증상을 입력해주세요. (쉼표로 구분 가능)"
                hide-details
                class="as-symptom-input"
              ></v-textarea>
            </template>

            <template slot="no-data">
              <div class="noDataProductInfos">정품 인증 코드 생성 및 미인증 설정한 상품이 없습니다.</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      items: [],
      headers: [
        { text: "이미지", value: "image", align: "center", sortable: false, width: 80 },
        { text: "상품 정보", value: "product_info", align: "start", sortable: false },
        { text: "AS 고장 증상 입력", value: "symptoms", align: "center", sortable: false, width: "60%" },
      ],
      adminDefaultImg: require("@/assets/authservice/images/admin_default.png"),
    };
  },
  mixins: [CommonMixin],
  methods: {
    async open() {
      this.dialog = true;
      await this.fetchItems();
    },
    close() {
      this.dialog = false;
    },
    async fetchItems() {
      this.loading = true;
      try {
        await this.waitForShopNo();
        const data = await M.api(M.entry("/as/symptoms/products"), { limit: 1000, offset: 0 });
        const list = (data && data.items) || [];
        this.items = list.map((item) => ({
          product_no: item.product_no,
          product_name: item.product_name,
          variant_name: item.variant_name,
          product_code: item.product_code,
          list_image: item.list_image,
          symptoms: item.symptoms || item.symptom_text || "",
        }));
      } catch (e) {
        this.alertShow("A/S 고장 증상 목록 조회에 실패했습니다. 잠시 후 다시 시도해주세요.");
        /*
        if (confirm("테스트 데이터로 확인할래?")) {
          const sampleData = {
            count: 2,
            items: [
              {
                product_no: 122,
                product_name: "상품명",
                product_code: "P000000K",
                list_image: "https://surping1.cafe24.com/web/product/medium/201508/11_shop1_652063.jpg",
                symptoms: "본체 손상, 파손",
              },
              {
                product_no: 123,
                product_name: "상품명 2",
                product_code: "P00000AK",
                list_image: "https://surping1.cafe24.com/web/product/medium/201508/11_shop1_652063.jpg",
                symptoms: "본체 손상, 파손, 접촉불량",
              },
            ],
          };
          const list = (sampleData && sampleData.items) || [];
          this.items = list.map((item) => ({
            product_no: item.product_no,
            product_name: item.product_name,
            variant_name: item.variant_name,
            product_code: item.product_code,
            list_image: item.list_image,
            symptoms: item.symptoms || item.symptom_text || "",
          }));
        }
          */
      } finally {
        this.loading = false;
      }
    },
    async save() {
      try {
        await this.waitForShopNo();
        const payload = {
          items: this.items.map((item) => ({
            product_no: item.product_no,
            product_code: item.product_code,
            symptoms: item.symptoms,
          })),
        };
        await M.api(M.entry("/as/symptoms"), payload);
        this.alertShow("저장되었습니다.");
      } catch (e) {
        this.alertShow("A/S 고장 증상 저장에 실패했습니다. 잠시 후 다시 시도해주세요.");
      }
    },
  },
};
</script>

<style scoped>
.noDataProductInfos {
  padding: 50px 0;
  text-align: center;
  color: #666;
}

.info-chip {
  background-color: #d3d3d3;
  color: #000;
  font-size: 16px;
  padding: 14px 12px;
  border-radius: 4px;
  text-align: center;
}

.as-symptom-table >>> .v-data-table__wrapper {
  border: 1px solid #e0e0e0;
}

.image-row {
  padding: 10px 0;
}

.as-symptom-input >>> .v-input__control {
  border-radius: 3px;
  border: none;
}
.as-symptom-input >>> .v-input__slot {
  /* border: 1px solid #e0e0e0 !important;*/
  border: none;
  padding: 8px 10px;
  min-height: 56px !important;
  background-color: #fff;
  box-shadow: none;
}

.as-symptom-input >>> textarea {
  font-size: 12px;
  line-height: 1.4;
}
</style>
